import { useTranslation } from 'react-i18next';
import { Form, type FormListFieldData, Input, type ItemProperties, SelectInput, TextInput } from 'ui';
import type { TaskKindOption } from '../../../activity-types';

type TaskInputProperties = {
  disabledEdit: boolean;
  disabledEditWithings?: boolean;
  field: FormListFieldData;
  item: ItemProperties<Values>;
  onSelectTaskKind?: (kind: TaskKindOption) => void;
  placeholder: string;
  withKindSelect?: boolean;
};

type Values = {
  kind: TaskKindOption;
  name: string;
};

const TaskInput = ({
  disabledEdit,
  disabledEditWithings,
  field,
  item,
  onSelectTaskKind,
  placeholder,
  withKindSelect,
}: TaskInputProperties) => {
  const { t } = useTranslation();

  const withingOrderOptions = [
    { label: 'Manual', value: 'default' },
    { label: 'Withings weight', value: 'withings_weight' },
    { label: 'Withings duration', value: 'withings_duration' },
    { label: 'Withings distance', value: 'withings_distance' },
    { label: 'Withings calories', value: 'withings_calories' },
    { label: 'Withings steps', value: 'withings_steps' },
    { label: 'Withings heart rate', value: 'withings_heart_pulse' },
  ];

  return (
    <>
      <TextInput
        input={{
          disabled: disabledEdit,
          id: `task_name-${field.name}`,
          key: field.key,
          placeholder: t(placeholder),
        }}
        item={{
          ...field,
          label: item.label,
          name: [field.name, 'name'],
          rules: [{ required: true, whitespace: true }],
        }}
      />
      {withKindSelect ? (
        <SelectInput
          input={{
            allowClear: true,
            disabled: disabledEdit || disabledEditWithings,
            getOptionLabel: (option) => option.label,
            getOptionValue: (option) => option.value,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            onChange(kind: any) {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
              onSelectTaskKind?.(kind);
            },
            options: withingOrderOptions,
          }}
          item={{
            ...field,
            label: 'Type of response data',
            name: [field.name, 'kind'],
            rules: [{ required: true, whitespace: true }],
          }}
        />
      ) : null}
      {/* eslint-disable-next-line no-restricted-syntax -- Cannot add generic */}
      <Form.Item hidden name={[field.name, 'input']} noStyle>
        <Input />
      </Form.Item>
      {/* eslint-disable-next-line no-restricted-syntax -- Cannot add generic */}
      <Form.Item hidden name={[field.name, 'kind']} noStyle>
        <Input />
      </Form.Item>
    </>
  );
};

export default TaskInput;
